import produce from 'immer';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import useObservable from '../../modules/helpers/hooks/useObservable';

const SoundPreferences = {
  reservation: {
    key: 'reservation_status',
    label: 'Reservation',
    enabled: true,
  },
  survivorChat: {
    key: 'survivor_chat',
    label: 'New Message in Survivor Chat',
    enabled: true,
  },
  supervisorChat: {
    key: 'supervisior_chat',
    label: 'New Message in Supervisor Chat',
    enabled: false,
  },
  idleActivity: {
    key: 'idle_activity',
    label: 'Idle',
    enabled: false,
  },
} as const;

export type ISoundPreferences = typeof SoundPreferences;
export const SoundPreferenceKeys = ['reservation', 'survivorChat', 'supervisorChat', 'idleActivity'];

export interface ISoundState {
  type: string;
  preferences: ISoundPreferences;
  mute: boolean;
}

const initialState: ISoundState = {
  type: '',
  preferences: SoundPreferences,
  mute: false,
};

const subject = new BehaviorSubject(initialState);

export const SoundOptions = {
  setType: (type: string): void => {
    const state = produce(subject.value, (draftState) => {
      draftState.type = type;
    });
    subject.next(state);
  },
  setPreferenceFor: (type: keyof ISoundPreferences, preference: boolean) => {
    const state = produce(subject.value, (draftState) => {
      draftState.preferences[type].enabled = preference;
    });
    subject.next(state);
  },
  setStaffChatSoundStatus: (status: boolean) => {
    const state = produce(subject.value, (draftState) => {
      draftState.mute = status;
    });
    subject.next(state);
  },
};

export default function useSoundStore(): ISoundState {
  return useObservable<ISoundState>(subject, subject.value);
}
